import * as tslib_1 from "tslib";
import { Vue, Prop, Component } from 'vue-property-decorator';
let ShareDiv = class ShareDiv extends Vue {
};
tslib_1.__decorate([
    Prop()
], ShareDiv.prototype, "close", void 0);
tslib_1.__decorate([
    Prop()
], ShareDiv.prototype, "title", void 0);
tslib_1.__decorate([
    Prop()
], ShareDiv.prototype, "remark", void 0);
tslib_1.__decorate([
    Prop()
], ShareDiv.prototype, "clickText", void 0);
tslib_1.__decorate([
    Prop()
], ShareDiv.prototype, "clickButton", void 0);
ShareDiv = tslib_1.__decorate([
    Component({})
], ShareDiv);
export default ShareDiv;
